export default "/kiban/_next/static/images/32_10L_1-8-1-598b8e105bf257663f81c2f975323b13.png";